import { AuthNavigation } from '@assetron/web-common/hooks/AuthNavigation';
import { useNavigate } from 'react-router-dom';
import { QueryParamPersistence } from '@assetron/web-common/utils/queryParamPersistence';

export const useNavigation = () => {
  const navigate = useNavigate();
  const authNavigation = AuthNavigation();
  
  // Helper function to navigate with query parameters
  const navigateWithQueryParams = (path: string, state?: { step: string }) => {
    const pathWithParams = QueryParamPersistence.addPersistedParamsToPath(path);
    navigate(pathWithParams, state ? { state } : undefined);
  };
  
  // Override navigation functions to include query parameters
  const navigateToSignInLanding = () => {
    navigateWithQueryParams('/sign-in');
  };
  
  const navigateToSignUpLanding = () => {
    navigateWithQueryParams('/sign-up', { step: 'landing' });
  };

  const navigateToSignUpDetails = () => {
    navigateWithQueryParams('/sign-up', { step: 'details' });
  };

  const navigateToSignUpEmailVerification = () => {
    navigateWithQueryParams('/sign-up', { step: 'emailVerification' });
  };

  const navigateToSignUpCreatePassword = () => {
    navigateWithQueryParams('/sign-up', { step: 'createPassword' });
  };

  const navigateToResetPassword = () => {
    navigateWithQueryParams('/reset-password', { step: 'enterEmail' });
  };

  const navigateToResetPasswordEmailVerification = () => {
    navigateWithQueryParams('/reset-password', { step: 'emailVerification' });
  };

  const navigateToResetPasswordCreatePassword = () => {
    navigateWithQueryParams('/reset-password', { step: 'createPassword' });
  };

  const navigateToResetPasswordSuccess = () => {
    navigateWithQueryParams('/reset-password', { step: 'success' });
  };

  return {
    ...authNavigation,
    // Override specific navigation functions with query parameter support
    navigateToSignInLanding,
    navigateToSignUpLanding,
    navigateToSignUpDetails,
    navigateToSignUpEmailVerification,
    navigateToSignUpCreatePassword,
    navigateToResetPassword,
    navigateToResetPasswordEmailVerification,
    navigateToResetPasswordCreatePassword,
    navigateToResetPasswordSuccess,
  };
};
